<template>
  <div class="panel-content" v-if="currItem.answers">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="example" v-if="!isSPC">
      {{ currItem.is_example ? $t('hsk_example') : currItem.index }}
    </div>
    <!-- 填空选项 -->
    <div class="panel-content-input">
      <div
        class="input-item"
        v-for="(item, index) in inputAnswers"
        :key="index"
        @click="clickItem(index, item)"
        v-if="item.text"
      >
        {{ item.text }}
      </div>
      <div class="input-line"></div>
    </div>
    <!-- 答案选项 -->
    <div class="panel-content-answer">
      <ul class="answer-list" ref="answers">
        <li
          v-for="(option, index) in currItem.choose"
          :key="`${currItem.index}${index}`"
          class="answer-item"
          :ref="`refAnswer${option.index}`"
          @click="checkHandler($event, option)"
        >
          {{ option.content }}
        </li>
      </ul>
    </div>
    <!-- 结果提示 -->
    <div
      class="panel-content-result result-correct"
      v-if="!isExamMode && isCorrect && !currItem.is_example"
    >
      <p class="correct-tips">
        {{ $t('textbook_chioce_word_text_correct_tip') }}
      </p>
      <div class="correct-box" v-show="analysisText">
        <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
        <p class="correct-box-answer" v-html="analysisText"></p>
      </div>
    </div>

    <div
      class="panel-content-result result-error"
      v-if="!isExamMode && !isCorrect && !currItem.is_example"
    >
      <p class="error-tips">
        {{ $t('textbook_chioce_word_text_error_tip') }}
      </p>
      <div class="result-show">
        <p class="correct-answer">
          {{ $t('hsk_correct_answer')
          }}<span
            style="padding-right: 15px"
            v-for="(answer, aIndex) in currItem.answers"
            :key="answer.answer_text"
            >{{ currItem.answers.length > 1 ? aIndex + 1 + '、' : ''
            }}{{ answer.answer_text }}</span
          >
        </p>
      </div>
      <div class="correct-box" v-show="analysisText">
        <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
        <p class="correct-box-answer" v-html="analysisText"></p>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionDescription from '@/components/hsk/questionDescription'
export default {
  components: { QuestionDescription },
  data() {
    return {
      // 试题数组
      items: [],
      // 当前小题Index
      currIndex: 0,
      blankType: '',
      // 当前小题填空项
      inputAnswers: [],
      // 是否已经提交
      isSubmit: false,
      // 禁止点击
      isDisabled: false,
      // 当前小题是否作答成功
      isCorrect: null,
      changeBtn: false,
      correctArray: [],
    }
  },
  computed: {
    // 正确答案
    correctAnswers() {
      return this.currItem.answers.map((item) => item.answer_text)
    },
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    analysisText() {
      return this.currItem.analysis[this.language]
        ? this.currItem.analysis[this.language].replace(/\……/g, '······')
        : this.currItem.analysis['cn'].replace(/\……/g, '······')
    },
  },
  watch: {
    currItem: {
      handler(val) {
        if (val && val.answers) {
          this.setInputAnswers()
        }
      },
      immediate: true,
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    isSPC: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    // 设置填空选项
    setInputAnswers() {
      this.correctArray = this.currItem.answers.map((item) => {
        return this.splitCorrectAnswers(item.answer)
      })
      if (this.currItem.is_example) {
        let correctAnswer = this.currItem.answers[0].answer
        this.inputAnswers = correctAnswer.map((item, index) => {
          return {
            text: this.searchText(item),
            answerIndex: index,
          }
        })
      } else if (this.currItem.answer) {
        let myAnswerArray = this.currItem.answer.split(',').filter((item) => item)
        if (myAnswerArray.length == this.currItem.choose.length) {
          this.inputAnswers = myAnswerArray.map((item, index) => {
            return {
              text: this.searchText(item),
              answerIndex: index,
            }
          })
        } else {
          this.inputAnswers = myAnswerArray.map((item, index) => {
            return {
              text: this.searchText(item),
              answerIndex: index,
            }
          })
          this.currItem.choose.map((item, index) => {
            if (index >= myAnswerArray.length) {
              this.inputAnswers.push({
                text: '',
                answerIndex: index,
              })
            }
          })
        }

        this.$nextTick(() => {
          myAnswerArray.map((item) => {
            this.$refs[`refAnswer${item}`][0].classList.add('active')
          })
        })
        //查看结果情况下判断是否回答正确
        if (!this.isExamMode) {
          let correctAnswers = this.currItem.answers.map((item) => {
            return item.answer.join('')
          })
          let myAnswerArray = this.currItem.answer.split(',').filter((item) => item)
          this.isCorrect = correctAnswers.includes(myAnswerArray.join(''))
        }
      } else {
        this.inputAnswers = this.currItem.choose.map((item, index) => {
          return {
            text: '',
            answerIndex: index,
          }
        })
      }
    },
    //点击上方input区块
    clickItem(inputIndex, item) {
      if (this.currItem.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }
      if (item.text) {
        let removeindex = this.currItem.choose.findIndex(
          (chooseItem) => item.text === chooseItem.content
        )
        this.removeInput({
          inputIndex: inputIndex,
          answerIndex: removeindex,
        })
      }
    },
    // 点击答题
    checkHandler(event, option) {
      if (this.currItem.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }
      const target = event.currentTarget
      if (target.classList.contains('active')) {
        // 已选择则取消
        target.classList.remove('active')
        const chooseIndex = this.inputAnswers.findIndex((item) => item.text === option.content)
        this.cancleInput(chooseIndex)
      } else {
        // 未选择
        const emptyInputIndex = this.inputAnswers.findIndex((item) => item.text === '')
        if (emptyInputIndex == -1) return

        target.classList.add('active')

        this.inputAnswers.splice(emptyInputIndex, 1, {
          answerIndex: emptyInputIndex,
          text: option.content,
        })
      }
      this.handleSubmit()
    },
    // 点击填空，取消答案
    removeInput({ inputIndex, answerIndex }) {
      if (this.currItem.is_example) {
        return
      }
      if (!this.isExamMode) {
        return
      }
      this.$refs[`refAnswer${answerIndex + 1}`][0].classList.remove('active')
      this.cancleInput(inputIndex)
      this.handleSubmit()
    },
    checkIndexAnswer(correctAnswerArr, userAnswerArr) {
      let num = 0
      userAnswerArr.forEach((item, index) => {
        if (item == correctAnswerArr[index]) {
          num++
        }
      })
      return num
    },

    // 提交
    handleSubmit() {
      // 1.正确数组顺序 2.作答顺序 3.作答顺序是否相同，相同+1；4.计算分数
      if (this.currItem.is_example) {
        return
      }
      // 判断答案是否正确
      let correctAnswers = this.currItem.answers.map((item) => {
        return item.answer.join('')
      })
      let array = this.inputAnswers.filter(function (item) {
        return item.text
      })
      let anserArray = array.map((item) => {
        return this.searchIndex(item.text)
      })
      let anserArraySubmit = this.inputAnswers.map((item) => {
        return this.searchIndex(item.text)
      })
      let userAnswer = anserArray.join('')
      let userAnswerSubmit = anserArraySubmit.join(',')
      this.isCorrect = correctAnswers.includes(userAnswer)
      // 计算分数
      let correctArrayIndex = this.currItem.answers.map((item) => {
        return item.answer
      })
      let newNumArray = correctArrayIndex.map((item) => {
        return this.checkIndexAnswer(item, anserArray)
      })
      //多个答案情况下，取节点匹配最多的数量
      let max = newNumArray.reduce((a, b) => {
        return b > a ? b : a
      })

      let myScore = Math.floor((max / this.currItem.choose.length) * this.currItem.score)
      if (anserArray.length < 2) {
        // 只选一个不得分
        myScore = 0
      }
      if (this.isCorrect) {
        //防止全对计算有小数点向下取整
        myScore = this.currItem.score
      }
      // 作答的对象
      let ansObj = {
        questionId: this.currItem.index,
        answer: userAnswerSubmit,
        judge: this.isCorrect ? 1 : 0,
        scores: myScore,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        // num: this.currItem.num,
        // nnum: this.currItem.nnum,
      }
      console.log('ansObj1====', ansObj)
      //选中后延时1s再提交
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },
    //判断某个index的text
    searchText(index) {
      let content = ''
      for (let i = 0; i < this.currItem.choose.length; i++) {
        if (this.currItem.choose[i].index == index) {
          content = this.currItem.choose[i].content
        }
      }
      return content
    },
    //根据某个text判断下标，提交答案时使用
    searchIndex(text) {
      if (!text) {
        return ''
      }
      let indexObj = this.currItem.choose.find((item) => item.content === text)
      return indexObj.index
    },
    //取消input数组中某个，重新进行排序
    cancleInput(inputIndex) {
      this.inputAnswers.splice(inputIndex, 1, {
        answerIndex: this.currItem.choose.length,
        text: '',
      })
      this.inputAnswers.forEach((element, index) => {
        if (index > inputIndex) {
          element = {
            answerIndex: element.answerIndex > 1 ? element.answerIndex - 1 : element.answerIndex,
            text: element.text,
          }
          this.$set(this.inputAnswers, index, element)
        }
      })
      this.inputAnswers.sort(this.compare('answerIndex'))
    },
    // 数组数值排序
    compare(property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    //将正确答案拆分两两分组
    splitCorrectAnswers(array) {
      let length = this.currItem.choose.length
      let answerArray = []
      this.currItem.choose.map((item, index) => {
        if (index < length - 1) {
          answerArray.push('')
        }
      })
      answerArray = answerArray.map((element, index) => {
        return array[index] + '' + array[index + 1]
      })
      return answerArray
    },
    //查看最终答案包含几个答案分组节点
    checkNodeNum(nodeArray, answerStr) {
      let num = 0
      nodeArray.forEach((item) => {
        if (answerStr.indexOf(item) > -1) {
          num++
        }
      })
      return num
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 90px 29px 0px 29px;
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  .example {
    background: rgba(63, 70, 81, 1);
    border-radius: 4px;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    position: absolute;
    top: 40px;
    left: 28px;
    min-width: 20px;
    display: flex;
    justify-content: center;
  }
  &-answer {
    margin: 80px 0 40px 0;

    .answer-list {
      width: 626px;
      margin: 0 auto;
      background: #fafafb;
      border-radius: 4px;
      padding: 20px 16px;

      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .answer-item {
        cursor: pointer;
        height: 30px;
        margin: 10px;
        padding: 0px 15px;
        border: 1px solid #515571;
        border-radius: 4px;
        background: #ffffff;
        color: #2c2f46;
        font-size: 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        &:hover {
          opacity: 0.6;
        }
        &.active {
          opacity: 0.2;

          // ::v-deepp.pinyin > span {
          //   color: #838996 !important;
          // }
          // ::v-deepp.hz > span {
          //   color: #838996 !important;
          // }
        }
      }
    }
  }
  &-result {
    padding: 40px 30px 20px 0;
    border-top: 1px dashed #e6eaef;
    width: 100%;
    &.result-error,
    &.result-correct {
      p.error-tips {
        font-size: 14px;
        color: #fc5a5a;
        margin-bottom: 20px;
      }
      p.correct-tips {
        font-size: 14px;
        color: rgba(9, 203, 160, 1);
        margin-bottom: 20px;
      }
      .result-show {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
      .your-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
        img {
          width: 12px;
          height: 12px;
          margin-left: 20px;
        }
      }
      p.correct-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
      }
      .correct-box {
        background: rgba(251, 252, 255, 1);
        border: 1px solid rgba(242, 243, 247, 1);
        border-radius: 10px;
        padding: 20px;

        &-title {
          font-size: 14px;
          font-weight: bold;
          color: rgba(63, 70, 81, 1);
          margin-bottom: 10px;
        }
        &-answer {
          font-size: 14px;
          font-weight: 400;
          color: rgba(84, 89, 97, 1);
          line-height: 21px;
          white-space: pre-line;
        }
      }
    }
  }
  &-input {
    width: 626px;
    min-height: 50px;
    display: flex;
    flex-wrap: wrap;
    margin: 20px auto;
    position: relative;
    .input-item {
      cursor: pointer;
      height: 30px;
      margin: 0px 10px 20px 0px;
      padding: 0px 15px;
      border: 1px solid rgba(207, 213, 222, 1);
      border-radius: 4px;
      background: rgba(242, 243, 247, 1);
      color: #3f4651;
      font-size: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .input-line {
      width: 626px;
      height: 1px;
      background-color: #3f4651;
      margin: 0 auto;
      position: absolute;
      bottom: 0px;
      left: 0px;
    }
  }
}
</style>
